﻿import $ from "jquery";

$(() => {
    const $overlay = $("#menuOverlay");
    const $btnToggle = $("#menuToggleBtn");
    const $btnCloseMobile = $("#menuCloseBtn");
    const $btnCloseDesktop = $("#menuCloseBtnDesktop");
    const $body = $("body");

    function setMenu(open: boolean) {
        if ($overlay.length === 0) return;

        $overlay.toggleClass("d-none", !open);
        $body.toggleClass("overflow-hidden", open);
        $overlay.attr("aria-hidden", (!open).toString());
    }

    $btnToggle.on("click", () => setMenu(true));
    $btnCloseMobile.on("click", () => setMenu(false));
    $btnCloseDesktop.on("click", () => setMenu(false));

    // klik mimo obsahu – zavrie overlay (môžeš vypnúť ak nechceš)
    $overlay.on("click", (e) => {
        if (e.target === $overlay[0]) {
            setMenu(false);
        }
    });

    // ESC
    $(document).on("keydown", (e) => {
        if (e.key === "Escape") {
            setMenu(false);
        }
    });
});
